import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withState from 'recompose/withState';

import SupportModal from './SupportModal';

import styles from './SupportWidget.css';

const SupportWidget = ({
  visible, setVisible,
}) => {
  const handleClick = () => {
    setVisible(!visible);
  };
  return (
    <React.Fragment>
      <SupportModal
        closeWidget={() => setVisible(false)}
        isVisible={visible}
      />
      <button
        className={styles.floatBtn}
        onClick={handleClick}
        aria-label="Help"
        aria-expanded={visible}
      >
        ?
      </button>
    </React.Fragment>
  );
};

SupportWidget.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};

export default compose(
  withState('visible', 'setVisible', false),
)(SupportWidget);



// WEBPACK FOOTER //
// ./src/client/Components/SupportWidget/SupportWidget.js